// Fallback defaults only. The real buckets are injected by the host through the
// `config` prop (controller.config.ISCHART_INFORMATICS_GS / ISCHART_STUDIO_GS).
// These apply when the host omits them (e.g. this repo runs with useCloud=false).
export const ISCHART_STUDIO_GS = "gs://ischart-studio"
export const ISCHART_INFORMATICS_GS = "gs://mehealthportal-informatics"